<template lang="html">
  <div class="preferences">
    <Navigation :routesList="routesList" class="nav"/>
    <router-view class="body"/>
  </div>
</template>

<script>
import Navigation from './Navigation.vue'

export default {
  name: 'vacancy-preferences-scene-content',

  components: {
    Navigation
  },

  props: {
    vacancy: Object
  },

  methods: {
    fetch () {
      return Promise.all([
        this.$store.dispatch('users/fetchUsers'),
        this.$store.dispatch('dictionary/fetchPermissions'),
        this.$store.dispatch('vacancy/fetchPermissions', this.vacancy),
        this.$store.dispatch('vacancy/invitation/fetch', { vacancyId: this.vacancy.id })
      ])
    }
  },

  computed: {
    user () {
      return this.$store.getters['user/current']
    },

    routesList () {
      return this.$store.getters['situation/vacancy/preferences/getRoutesList']
    }
  },

  watch: {
    vacancy () {
      this.fetch()
    }
  },

  beforeMount () {
    this.fetch()
  },

  mounted () {
    // triple $parent, because of use of proxy components: Scene -> SceneProcess -> SceneContent
    // event occured before Scene component
    this.$parent.$parent.$parent.$on('save', () => {
      this.$emit('saveOnParent')
    })
  },

  destroyed () {
    this.$parent.$parent.$parent.$off('save')
  }
}
</script>

<style lang="scss" scoped>
  .preferences {
    width: 100%;
    max-width: inherit;
    margin: inherit;
    display: flex;
    flex-direction: row;

    .nav {
      margin-top: 10px;
      width: 200px;
      flex: 0 0 200px;
    }

    .body {
      width: 100%;
    }
  }
</style>
